export default __webpack_public_path__ + "static/media/faceone.3c4b8eee.svg";